import { useRouter } from 'next/navigation';
import { IconMessage, IconShoppingCart } from '@tabler/icons-react';
import { ActionIcon, Box, Indicator } from '@mantine/core';
import { UserAvatarMenu } from '../actions/user-avatar-menu';

interface IHeaderActionListAuthenticatedProps {
  cartItemCount: number;
}

const CART_ITEM_COUNT_THRESHOLD = 9;

export function HeaderActionListAuthenticated({
  cartItemCount,
}: IHeaderActionListAuthenticatedProps) {
  const router = useRouter();

  const cartItemCountLabel =
    cartItemCount > CART_ITEM_COUNT_THRESHOLD ? '9+' : cartItemCount.toString();
  const showCartIndicator = cartItemCount > 0;

  return (
    <>
      <ActionIcon
        variant="subtle"
        color="gray"
        size="lg"
        component="a"
        onClick={() => router.push('/chat')}
      >
        <IconMessage size={22} stroke={1.5} />
      </ActionIcon>

      <Indicator
        inline
        label={cartItemCountLabel}
        size={16}
        color="red"
        offset={4}
        disabled={!showCartIndicator}
      >
        <ActionIcon
          variant="subtle"
          color="gray"
          size="lg"
          onClick={() => router.push('/cart')}
        >
          <IconShoppingCart size={22} stroke={1.5} />
        </ActionIcon>
      </Indicator>

      {/* Bakal di pindahin ke navbar bawah kalo mode mobile */}
      <Box ml="0.5rem">
        <UserAvatarMenu />
      </Box>
    </>
  );
}
